/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { css, cx } from "@panda/css";

import { Box, BoxProps } from "@panda/jsx";

const tableStyles = css({
	width: "100%",
	display: "grid",
	overflowX: "auto",
});

export interface CosmosTableProps extends BoxProps {
	children?: React.ReactNode;
	className?: string;
}

/**
 * Expects to wrap TableHeader and TableBody
 */

export const CosmosTable = ({ children, className, ...props }: CosmosTableProps): React.JSX.Element => {
	return (
		<Box gap="eds.dimension.2" {...props} className={cx("cosmos-table", tableStyles, className)}>
			{children}
		</Box>
	);
};

CosmosTable.displayName = "CosmosTable";
